import { axios } from '../../../plugins/axios'
import ArmeriaApiRepository from '../../../modules/armeria/infrastructure/ArmeriaApiRepository'
import GetPersonalByLoc from '../../../modules/armeria/application/GetPersonalByLoc.usecase'

const armeriaRepository = new ArmeriaApiRepository()
const getPersonalByLocUseCase = new GetPersonalByLoc(armeriaRepository)

export default {
  namespaced: true,

  state: {
    personalLoc: [],
    personalByLoc: [],
  },

  getters: {
    getPersonalLoc: (state) => {
      return state.personalLoc
    },
    getPersonalByLoc: (state) => {
      return state.personalByLoc
    },
  },

  mutations: {
    SET_PERSONAL_LOC: (state, personalLoc) => {
      state.personalLoc = personalLoc
    },
    SET_PERSONAL_BY_LOC: (state, personal) => {
      state.personalByLoc = Array.isArray(personal) ? personal : []
    },
  },

  actions: {
    fetchPersonalByLoc: async function ({ commit }, idLoc) {
      try {
        const result = await getPersonalByLocUseCase.execute(idLoc)
        commit('SET_PERSONAL_BY_LOC', result)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al obtener el personal de la LOC.', { root: true })
      }
    },

    fetchPersonalLoc: async function ({ commit }, idPersonal) {
      await axios
        .get('/PoliciaCuadrantes/Armeria/personal/' + idPersonal + '/personalLoc')
        .then((response) => {
          commit('SET_PERSONAL_LOC', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    savePersonalLoc: async function (context, personalLoc) {
      await axios
        .post('/PoliciaCuadrantes/Armeria/personal/' + personalLoc.idPersonal + '/personalLoc', personalLoc)
        .then((response) => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Personal asignado a LOC correctamente.', { root: true })
        })
        .catch((error) => console.log(error))
    },

    updatePersonalLoc: async function ({ commit }, personalLoc) {
      await axios
        .post(
          '/PoliciaCuadrantes/Armeria/personal/' + personalLoc.idPersonal + '/personalLoc/' + personalLoc.fk_idLoc,
          personalLoc
        )
        .then((response) => {
          //console.log('OK')
        })
        .catch((error) => console.log(error))
    },
  },
}
